import { render } from "./additional-information.vue?vue&type=template&id=4f9e1d84"
import script from "./additional-information.vue?vue&type=script&lang=js"
export * from "./additional-information.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__